export default "__VITE_ASSET__BObb8Jvr__"